import { render } from "./finish-26.vue?vue&type=template&id=6fd6141f&scoped=true"
import script from "./finish-26.vue?vue&type=script&lang=js"
export * from "./finish-26.vue?vue&type=script&lang=js"

import "./finish-26.vue?vue&type=style&index=0&id=6fd6141f&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd6141f"]])

export default __exports__